import React from "react";
import { Button, Descriptions, Drawer, Space, Tag, Typography } from "antd";
import { EditOutlined } from "@ant-design/icons";

export default function RoleDetailsDrawer({ open, onClose, role, onEdit }) {
  const synonyms = Array.isArray(role?.synonyms) ? role.synonyms : [];

  return (
    <Drawer
      title="Profession Role"
      width={640}
      open={open}
      onClose={onClose}
      destroyOnClose
      placement="right"
      zIndex={2000}
      extra={
        onEdit ? (
          <Button icon={<EditOutlined />} type="primary" onClick={() => onEdit(role)}>
            Edit
          </Button>
        ) : null
      }
    >
      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        <Descriptions bordered size="small" column={1}>
          <Descriptions.Item label="ID">{role?.id || "-"}</Descriptions.Item>
          <Descriptions.Item label="Title">{role?.title || "-"}</Descriptions.Item>
          <Descriptions.Item label="Description">
            <Typography.Paragraph style={{ marginBottom: 0, whiteSpace: "pre-wrap" }}>
              {role?.description || "-"}
            </Typography.Paragraph>
          </Descriptions.Item>
          <Descriptions.Item label="Synonyms">
            {synonyms.length ? synonyms.map((item) => <Tag key={item}>{item}</Tag>) : "-"}
          </Descriptions.Item>
        </Descriptions>
      </Space>
    </Drawer>
  );
}

